import { Box, Typography } from "@mui/material";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import React, { useEffect, useState } from "react";
import { CirclePower } from "lucide-react";
import { SyncBadge } from "../../common/badges";

const OnOff1Widget = ({ widget, onValueUpdate, pattern }) => {
  const [isOn, setIsOn] = useState(false);
  const [v0, setV0] = useState();

  useEffect(() => {
    setV0(widget);
    if (widget?.items?.$w1) {
      if (widget.items.$w1.value === "on") {
        setIsOn(true);
      } else {
        setIsOn(false);
      }
    }
    return () => {};
  }, [widget]);

  const handleValueUpdate = (data) => {
    const updatedWidget = {
      ...v0.items.$w1,
      value: data ? "on" : "off",
    };
    onValueUpdate(updatedWidget);
  };

  const handleToggle = () => {
    const newValue = !isOn;
    setIsOn(newValue);
    handleValueUpdate(newValue);
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        cursor: pattern && pattern.endsWith("_R") ? "default" : "pointer",
        opacity: pattern && pattern.endsWith("_R") ? 0.8 : 1,
        position: "relative",
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (pattern && pattern.endsWith("_R")) return;
        handleToggle();
      }}
    >
      <Box
        sx={{
          height: "100%",
          aspectRatio: "1/1",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <CirclePower
          size="100%"
          color={isOn ? "#FFD700" : "#B0B0B0"}
          fill={isOn ? "#FFD700" : "#B0B0B0"}
          fillOpacity={0.2}
          strokeWidth={2}
          style={{
            width: "100%",
            height: "100%",
          }}
        />
        {pattern && pattern.endsWith("_W") && <SyncBadge />}
      </Box>
    </Box>
  );
};

export default OnOff1Widget;
